<!-- components/Loader.vue -->
<template>
  <div class="loader-overlay">
    <div class="loader"></div>
  </div>
</template>

<script>
export default {
name: 'LoadingTable',
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style scoped>
.loader-overlay {
  position: relative;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999; /* выше всех остальных элементов */
}

.loader {
  border: 3px solid #f3f3f3; /* Светлый серый */
  border-top: 3px solid #005eeb; /* Синий */
  border-radius: 50%;
  width: 20px;
  height: 20px;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
</style>
